import { useState, useEffect } from 'react'
import { Button } from '@stratascratch/ui'
import { ArrowUpCircle } from '@stratascratch/icons'
import { button } from './GoToTop.module.css'

function GoToTop() {
  const [showButton, setShowButton] = useState(false)

  function onScroll() {
    if (window.scrollY > 400) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }

  const goToTop = () => {
    window.scrollTo({ top: 0 })
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  if (!showButton) {
    return null
  }

  return (
    <Button as="button" size="circle" onClick={goToTop} className={button}>
      <ArrowUpCircle style={{ fontSize: 26 }} />
    </Button>
  )
}

export default GoToTop
